import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from 'src/environments/environment';

(window as any).googleMapsApiKey = environment.googleMapsApiKey;
bootstrapApplication(AppComponent, appConfig)
.then(() => {
    const event = new Event('appReady');
    window.dispatchEvent(event);
  })
.catch((err) =>
  console.error(err)
);
